/**
 * @typedef {(DIE | IDLE | MOVE | START)} TypeAction An action.
 */

/**
 * The 'DIE' action.
 * @type {'ACTION_DIE'}
 * @constant
 */
const DIE = 'ACTION_DIE';

/**
 * The 'IDLE' action.
 * @type {'ACTION_IDLE'}
 * @constant
 */
const IDLE = 'ACTION_IDLE';

/**
 * The 'MOVE' action.
 * @type {'ACTION_MOVE'}
 * @constant
 */
const MOVE = 'ACTION_MOVE';

/**
 * The 'START' action.
 * @type {'ACTION_START'}
 * @constant
 */
const START = 'ACTION_START';

export {

    DIE,
    IDLE,
    MOVE,
    START
};
